import { NestApiProvider } from "../../nest-api";
import { Injectable } from "@angular/core";
import { ResponseAddDto } from "../dto/on-duty-cancellation.dto";
import { Observable } from "rxjs";

@Injectable()
export class OnDutyCancellationApi {
  private readonly service: string = '';
  private readonly model: string = 'sf6s/ondutyCancel';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public add(payload: any): Observable<ResponseAddDto> {
    const method: string = 'POST';
    const func: string = 'add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddDto>(method, url, params, urlParams, body);
  }

  public save(payload: any): Observable<ResponseAddDto> {
    const method: string = 'POST';
    const func: string = 'save';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddDto>(method, url, params, urlParams, body);
  }

  public delete(payload: any): Observable<ResponseAddDto> {
    const method: string = 'POST';
    const func: string = 'delete';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddDto>(method, url, params, urlParams, body);
  }

  public feedCancellation(requestNo: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'feedCancellation';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/on-duty-cancellation.api.ts